import React, { useMemo } from "react";
import { View, Image } from "react-native";
import { DocsInfoConstants, FORMAT_TYPE } from "@lib/utilities/Constants";

import InfoListSection from "../../components/common/InfoListSection";
import PolicyHolderSection from "../../components/common/PolicyHolderSection";
import PdfItem from "./PDFItem";
import { ids, styles } from "./Style";
import { checkValidationForArray } from "@lib/utilities/Helpers";
import { useAppSelector } from "@lib";
import { formattedMailingAddress } from "@lib/utilities/Formatters";

interface DocumentsInfoProps {
  documentsArray: any[];
  currentIndex: number;
  moveNextPreviousHorizontalFlatlist: (isNext: boolean) => void;
  flatListRef: React.RefObject<any>;
  onViewableItemsChanged: (info: any) => void;
  onPdfItemTap: (item: any) => void;
}

const DocumentsInfo: React.FC<DocumentsInfoProps> = ({
  documentsArray,
  currentIndex,
  moveNextPreviousHorizontalFlatlist,
  flatListRef,
  onViewableItemsChanged,
  onPdfItemTap,
}) => {
  const { policyHolders, coverageDetails, mailingAddress, effectiveDate, endDate } = useAppSelector(
    (state) => state.policyDetailReducer
  );

  const renderSection = (
    condition: boolean,
    Component: React.FC<any>,
    props: any,
    index: number
  ) => {
    return condition ? <Component key={index + ""} {...props} /> : null;
  };

  const MemoizedPdfItem = useMemo(
    () => (
      <PdfItem
        documentsArray={documentsArray}
        currentIndex={currentIndex}
        moveNextPreviousHorizontalFlatlist={moveNextPreviousHorizontalFlatlist}
        flatListRef={flatListRef}
        onViewableItemsChanged={onViewableItemsChanged}
        onPdfItemTap={onPdfItemTap}
      />
    ),
    [
      documentsArray,
      currentIndex,
      moveNextPreviousHorizontalFlatlist,
      flatListRef,
      onViewableItemsChanged,
      onPdfItemTap,
    ]
  );
  coverageDetails.coverageLimits;
  coverageDetails.surcharges;
  coverageDetails.deductibles;

  const documentInfoDetails = [
    {
      component: PolicyHolderSection,
      props: {
        policyHolders: policyHolders,
        mailingAddress: formattedMailingAddress(mailingAddress),
        effectiveDate,
        endDate
      },
      validationArray: policyHolders,
      page: "docs",
    },
    {
      component: InfoListSection,
      props: {
        title: DocsInfoConstants.coverageLimits,
        items: coverageDetails.combinedCoverages,
        headerStyle: "primary",
        listType: "secondary",
        page: "docs",
      },
      validationArray: coverageDetails.coverageLimits,
    },
    {
      component: InfoListSection,
      props: {
        title: DocsInfoConstants.surchargesDiscounts,
        items: coverageDetails.surcharges,
        headerStyle: "secondary",
        listType: "secondary",
        page: "docs",
      },
      validationArray: coverageDetails.surcharges,
    },
    {
      component: InfoListSection,
      props: {
        title: DocsInfoConstants.deductibles,
        items: coverageDetails.deductibles,
        headerStyle: "secondary",
        listType: "primary",
        page: "docs",
      },
      validationArray: coverageDetails.deductibles,
    },
  ];

  return (
    <View style={[styles.container]} dataSet={{ media: ids.container }}>
      <View style={styles.docInfoCtr} dataSet={{ media: ids.docInfoCtr }}>
        <View style={[styles.claimDetail]} dataSet={{ media: ids.claimDetail }}>
          {documentInfoDetails.map((item, index) =>
            renderSection(
              checkValidationForArray(item?.validationArray),
              item?.component,
              item.props,
              index
            )
          )}
        </View>
        {MemoizedPdfItem}
      </View>
    </View>
  );
};

export default DocumentsInfo;
